// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"MealSelect_style_contentWrap__1mi62","imageWrap":"MealSelect_style_imageWrap__2IJt7","imageWrap2":"MealSelect_style_imageWrap2__26rPl"};